import * as React from "react";
import Tooltip from "../../base/Tooltip/Tooltip";

const ProductColumn: React.FC<{ product: Product }> = ({ product }) => {
    const content = (
        <>
            <label>Varenummer</label>
            <p style={{ userSelect: "all" }}>{product.no}</p>
        </>
    );

    const tooltipContent = (
        <>
            {product.isVINitem && product.oEnumber && (
                <p>OE number: {product.oEnumber}</p>
            )}
            {product.isVINitem && product.material && (
                <p>Material: {product.material}</p>
            )}
            {product.euroCode && <p>Euro code: {product.euroCode}</p>}
            {product.description2 && (
                <p>Description2: {product.description2}</p>
            )}
            {product.description3 && (
                <p>Description3: {product.description3}</p>
            )}
            {product.description4 && (
                <p>Description4: {product.description4}</p>
            )}
        </>
    );

    if (
        product.material ||
        product.oEnumber ||
        product.euroCode ||
        product.description2 ||
        product.description3 ||
        product.description4
    ) {
        return <Tooltip content={tooltipContent}>{content}</Tooltip>;
    }

    return content;
};

export default ProductColumn;
